import * as React from 'react'
import { Button } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import { logRefTag } from '@utils'
import * as st from './copyLinkButton.module.scss'

type LinkWithCopyProps = {
  url: string
  reftag: string
  copyLinkText: string
  linkCopiedText: string
}

type LinkWithCopyState = {
  copied: Boolean
  buttonString: string
}

class CopyLinkButton extends React.PureComponent<LinkWithCopyProps, LinkWithCopyState> {

  readonly state = {
    copied: false,
    buttonString: this.props.copyLinkText
  }

  // Copies the current page url into the clipboard
  copyLink = (url: string) => {
    const textarea = document.createElement('textarea')
    textarea.value = url
    textarea.readOnly = true
    textarea.setAttribute('display', 'none')
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, url.length)
    document.execCommand('copy')
    textarea.remove()
  }

  onClickHandler = (e: MouseEvent) => {
    // Don't want to log on repeated clicks
    if (!this.state.copied) {
      logRefTag(this.props.reftag)
    }

    this.setState({ copied: true, buttonString: this.props.linkCopiedText })
    this.copyLink(this.props.url)
    e.stopPropagation()
  }

  render() {
    const { buttonString } = this.state
    return(
      <Button className={st.linkButton} onClick={this.onClickHandler} data-automation-id="copy-url-button"
              data-testid="copy-url-button">
        <Text string={buttonString}/>
      </Button>
    )
  }
}

export default CopyLinkButton
